import { Module, VuexModule, getModule, Mutation, Action } from 'vuex-module-decorators';
import store from '@/store';

export interface ISettingsState {
  sidebarLogoSrc: string,
  fixedHeader: boolean,
  sidebarLogo: boolean
}

@Module({ dynamic: true, store, name: 'settings' })
class Settings extends VuexModule implements ISettingsState {
  public sidebarLogoSrc = '';
  public fixedHeader = true;
  public sidebarLogo = true;

  @Mutation
  private CHANGE_SETTING(payload: { key: string, value: any}) {
    const { key, value } = payload;
    if (Object.prototype.hasOwnProperty.call(this, key)) {
      (this as any)[key] = value
    }
  }

  @Action
  public ChangeSetting(payload: { key: string, value: any}) {
    this.CHANGE_SETTING(payload)
  }
}

export const SettingsModule = getModule(Settings);
